module.exports = __webpack_public_path__ + "img/Photo_2___People_and_Pleasures_982_87_2_Boys_on_Canal.023416ad.jpg";